import { fixedNumber } from '../utils/math-util.js';

export const controlCenterEditServerModel = (data) => ({
    CourierAssociationMode: data.courierAssociationMode,
    PullFromAnyControlCenter: data.pullFromAnyControlCenter,
    AutomaticExtendCycle: data.automaticExtendCycle,
    AutomaticApproveCycle: data.automaticApproveCycle,
    DisableAutomationForPerHourCouriers: data.disableAutomationForPerHourCouriers,
    RunCourierAppInPointByPointMode: data.runCourierAppInPointByPointMode,
    EnableCollectOrdersStepAtPickup: data.enableCollectOrdersStepAtPickup,
    RunCourierAppInPointByPointModeAfterApprove: data.runCourierAppInPointByPointModeAfterApprove,
    CourierFeeBidsIncrease: (data.courierFeeBidsIncrease || [])
      .sort((a, b) => a - b)
      .map(percent => fixedNumber(percent / 100, 2)),
})